import { gql } from '@apollo/client';
const PREVIEW_CONFIGURATION_TO_RETRIEVE = `
    id
    configuration
    createdOn
    tool
    project_id
`;
export const GET_ALL_PREVIEW_CONFIGURATIONS = gql`
  query getAllPreviewConfigurations ($project_id :ID!, $tool: String!) {
    getAllPreviewConfigurations (project_id :$project_id, tool: $tool) {
      ${PREVIEW_CONFIGURATION_TO_RETRIEVE}
    }
}`;
export const CREATE_PREVIEW_CONFIGURATION_MUTATION = gql`
  mutation createPreviewConfiguration($project_id: ID!, $previewConfigurationInput: PreviewConfigurationInput!) {
    createPreviewConfiguration(project_id: $project_id, input: $previewConfigurationInput) { 
      ${PREVIEW_CONFIGURATION_TO_RETRIEVE}
    }
  }
`;
export const UPDATE_PREVIEW_CONFIGURATION_MUTATION = gql`
  mutation updatePreviewConfiguration($project_id: ID!, $id: ID!, $previewConfigurationInput: PreviewConfigurationInput!) {
    updatePreviewConfiguration(project_id: $project_id, id: $id, input: $previewConfigurationInput) { 
      ${PREVIEW_CONFIGURATION_TO_RETRIEVE}
    }
  }
`;
export const GET_ALL_PREVIEW_CONFIGURATIONS_OPTIONS = (project_id, tool, skip = false) => {
  return {
    variables: {
      project_id: project_id,
      tool: tool
    },
    skip: skip
  };
};
export const CREATE_PREVIEW_CONFIGURATION_OPTIONS = (project_id, previewConfiguration) => {
  return {
    variables: {
      project_id,
      previewConfigurationInput: {
        configuration: {
          ...previewConfiguration.configuration
        }
      }
    },
    fetchPolicy: 'no-cache'
  };
};
export const UPDATE_PREVIEW_CONFIGURATION_OPTIONS = (project_id, previewConfiguration) => {
  return {
    variables: {
      project_id,
      id: previewConfiguration.id,
      previewConfigurationInput: {
        configuration: {
          ...previewConfiguration.configuration
        }
      }
    },
    fetchPolicy: 'no-cache'
  };
};